(() => {
	'use strict';

	/*
	 * Block handling class
	 */
	class BlockHandler {
		/*
		 * Init the handler
		 *
		 * @param    {HTMLElement} rootEl    The root node of the block
		 */
		constructor(rootEl) {
			// Store some class-wide values
			this.productCardClass = 'product-card';
			this.proudctCardOpenClass = `${this.productCardClass}--form-open`;
			this.proudctCardFormClass = `${this.productCardClass}__form`;

			// Watch for click events
			rootEl.addEventListener(
				'click',
				this.#formRevealButtonClicked.bind(this)
			);
		}

		/*
		 * Handle the user clicking on a reveal form link
		 *
		 * @param     {MouseEvent} event    An event raised by the user action
		 * @return    {void}
		 */
		#formRevealButtonClicked(event) {
			// Short hand the event target and the expected matching selector
			const targetEl = event.target;
			const matchesSelector = `.${this.productCardClass} a[data-action="reveal-form"]`;

			// Target element (or it's children) must match this selector
			if (
				!targetEl.matches(matchesSelector) &&
				!targetEl.matches(`${matchesSelector} *`)
			) {
				return;
			}

			// Don't follow the link
			event.preventDefault();

			// Find required elements
			const buttonEl = targetEl.closest(matchesSelector);
			const cardEl = buttonEl.closest(`.${this.productCardClass}`);

			// Fail if the parent element is missing
			if (!(cardEl instanceof window.HTMLElement)) {
				return;
			}

			// Toggle the open class on the parent element
			cardEl.classList.toggle(this.proudctCardOpenClass);

			// Find the form container element
			const formEl = cardEl.querySelector(
				`.${this.proudctCardFormClass}`
			);

			// If the card is open and the form container element exists
			if (
				cardEl.classList.contains(this.proudctCardOpenClass) &&
				formEl instanceof window.HTMLElement
			) {
				// Scroll the form container element into view
				formEl.scrollIntoView({
					block: 'start',
				});
			}
		}
	}

	// Init a handler for all blocks
	const rootEls = document.querySelectorAll('.retentions-products-offered');
	rootEls.forEach((el) => new BlockHandler(el));
})();
